<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Satisfaction</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
      
<ion-content>
    <ion-list lines="none">
        <ion-list-header color="secondary">
            <ion-label class="ion-text-wrap">
                Answer these 3 questions (Step 2 of 2)
            </ion-label>
        </ion-list-header>

        <ion-item>
            <ion-label class="ion-text-wrap">
                Question 1) Using a 0-10 scale where '0 is Not Likely' and '10 is Very Likely', how likely 
                is it that you would recommend ShuttleNomix to another dealership?  &nbsp;<strong>{{vm.nps}}</strong>
            </ion-label>
        </ion-item>

        <ion-item class="ion-padding-bottom">
            <ion-range data-test="npsRange" class="insetRange" color="primary" min="0" max="10" snaps="true"
                [(ngModel)]="vm.nps" (ionChange)="onNpsChange()">
                <ion-label class="ion-text-wrap" color="primary" slot="start">0</ion-label>
                <ion-label class="ion-text-wrap" color="primary" slot="end">10</ion-label>
            </ion-range>
        </ion-item>

        <ion-item>
            <ion-label class="ion-text-wrap">
                Question 2) {{vm.question2}}
            </ion-label>
        </ion-item>

        <ion-item class="ion-padding-bottom">
            <ion-textarea data-test="answer2" type="text" [(ngModel)]="vm.answer2" rows="4" placeholder="Your Answer"></ion-textarea>
        </ion-item>

        <ion-item>
            <ion-label class="ion-text-wrap">
                Question 3) {{vm.question3}}
            </ion-label>
        </ion-item>

        <ion-item>
            <ion-textarea data-test="answer3" type="text" [(ngModel)]="vm.answer3" rows="4" placeholder="Your Answer"></ion-textarea>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="save" color="primary" expand="full" (click)="onSaveClick()">Save</ion-button>
    </ion-toolbar>
</ion-footer>
